angular.module('unica_invitation_transfer.invitation_transfer_services')

.factory('InvitationTransferCreateService', function ($http, getBaseApiURL) {

	var invitationTransferCreateService = {};

	invitationTransferCreateService.create = function ( invitationTransferData ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-transfer/create',
			data: invitationTransferData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_transfer;
			}

		});

	};

	return invitationTransferCreateService;
});

